import APopover from 'components/APopover';
import Button from 'components/Button';
import ChangeThumbnailModal from 'containers/Profile/Panels/DocumentManager/ChangeThumbnailModal';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IProviderItemView } from 'store/providers/providerTypes';
import { appDispatch } from 'store/store';
import styled from 'styled-components';
import { border1, exactWhite } from 'utils/style/colors';
import noImage from '../../../assets/images/noImage.png';

interface IProps {
  item: IProviderItemView;
}

const ThumbnailContainer = styled.div``;

const ScaledImage = styled.img`
  border: ${border1};
  height: 2.5rem;
  width: 2.5rem;
  border-radius: 1rem;
`;

const Container = styled.div`
  background: ${exactWhite};
  padding: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
`;

const APopoverImage = styled.img`
  width: 5rem;
  height: 5rem;
  border-radius: 1rem;
  border: ${border1};
`;

const HeaderThumbnail: FC<IProps> = ({ item }) => {
  const { t } = useTranslation('modals');

  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);

  return (
    <ThumbnailContainer>
      <ChangeThumbnailModal
        item={item}
        isOpen={modalIsOpen}
        dispatch={appDispatch}
        onCloseThumbnailModal={(status: boolean) => setModalIsOpen(status)}
      />
      <APopover
        target={
          <div>
            <ScaledImage src={item.thumbnailUrl ?? noImage} />
          </div>
        }
      >
        <Container>
          <APopoverImage src={item.thumbnailUrl ?? noImage} />
          <Button color="black-outline" onClick={() => setModalIsOpen(true)}>
            {t('chooseThumbnail')}
          </Button>
        </Container>
      </APopover>
    </ThumbnailContainer>
  );
};

export default HeaderThumbnail;
